import { render } from "./Footer.vue?vue&type=template&id=5248051c"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=5248051c&lang=scss"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__